import { useEffect, useRef, useState } from "react";
import Button from "../Button";
import Keyboard from "../Keyboard";
import React from "react";

export type InputModalProps = {
  value?: string;
  onSave(value: string): void;
  onCancel(): void;
  title: string;
  isOpen?: boolean;
  name?: string;
  password?: boolean;
};

function InputModal(props: InputModalProps) {
  const [inputValue, setInputValue] = useState(props.value || "");
  const inputRefData = useRef<any>(null);

  const [selection, setSelection] = useState(props.value?.length || 0)

  const [isTouch, setIsTouch] = useState(false)

  function keyboardInputValue(data: string) {
    setInputValue(data);
  }

  function save() {
    if ((props.password && inputValue.length < 4)) {
      return;
    }
    props.onSave(inputValue);
  }

  function cancel() {
    props.onCancel();
  }

  if (!props.isOpen) {
    return <div />;
  }

  const onBlueHandler = function () {
    if (inputRefData.current) {
      inputRefData.current.focus();
    }
  };


  const onChangeSelection = function (position: number) {
    inputRefData.current.selectionStart = position;
    inputRefData.current.selectionEnd = position;
  };

  const onTouchSelection = function (e: any) {
    setTimeout(() => {

      setSelection(inputRefData.current.selectionStart)
      setIsTouch(true)
    }, 100)
  }

  const onChangeTouch = function () {
    setIsTouch(false)
  }

  // 禁止长按全选
  const disableLongPressSelect = (e: any) => {
    e?.preventDefault();
  };






  return (
    <div className="fixed top-0 left-0 h-full w-full opacity-1 z-20 ">
      <div className="fixed inset-x-0 top-0 bg-red-100 m-auto w-2/4 mt-32 text-center bg-saveProgramDivBgColor pt-12 text-2xl font-bold">
        {props.name ? <div className="mb-4 text-4xl">{props.name}</div> : null}
        <label>{props.title}</label>
        <input
          ref={(r) => (inputRefData.current = r)}
          className="ml-2 w-96"
          onBlur={onBlueHandler}
          type={props.password ? "password" : undefined}
          style={{
            paddingLeft: 20,
            paddingBottom: 10,
            height: 74,
            fontSize: 40,
            userSelect: 'none',
            WebkitUserSelect: 'none',
          }}

          value={inputValue}
          autoFocus={true}
          onTouchEnd={e => onTouchSelection(e)}
          onContextMenu={disableLongPressSelect}
          onTouchStart={disableLongPressSelect}
          onTouchMove={disableLongPressSelect}
        />
        <div
          style={{
            marginBottom: 20,
          }}
          className="mt-10"
        >
          <Button
            options={{
              text: props.password ? "JOIN" : "Save",
              class: "bg-buttonKeyboardBgColor",
              cb: save,
              disabled: !inputValue,
            }}
            style={{
              backgroundColor:'#5ede4e',
            }}
          ></Button>
          <Button
            options={{
              text: "Cancel",
              class: "bg-buttonKeyboardBgColor",
              cb: cancel,
            }}
            style={{
              marginLeft: 25,
            }}
          ></Button>
        </div>
      </div>
      <Keyboard
        options={{
          cb: keyboardInputValue,
          onEnterFunc: save,
          defaultValue: props.value,
          onChangeSelection: onChangeSelection,
          selectionData: selection,
          isTouch: isTouch,
          onChangeTouch: onChangeTouch
        }}
      ></Keyboard>
    </div>
  );
}

export default InputModal;
